module.exports = __webpack_public_path__ + "static/facebook-post-54d5dd66fe6e5d9f81b65aad2f03c5dd.png";